import { render, staticRenderFns } from "./OrderCustomerEditVBI.vue?vue&type=template&id=4b1b3e6a&"
import script from "./OrderCustomerEditVBI.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerEditVBI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports